import { extend, override } from "flarum/extend";
import ItemList from "flarum/utils/ItemList";
import DiscussionComposer from "flarum/forum/components/DiscussionComposer";
import SimilarDiscussionsSearchSource from "./SimilarDiscussionsSearchSource";
import SearchState from "flarum/forum/states/SearchState";

app.initializers.add("lltq-similar-discussions", (app) => {
  extend(DiscussionComposer.prototype, "oninit", function (idk) {
    if (!this.similarSearches) this.similarSearches = new SearchState();
  });

  extend(DiscussionComposer.prototype, "headerItems", function (items) {
    if (!this.sources) {
      let sources = new ItemList();
      sources.add('similar_discussions', new SimilarDiscussionsSearchSource());
      sources = sources.toArray();
      if (!sources.length) return;
      this.sources = sources;
    }

    if (this.similarSearches.getValue()) {
      if (!items.items.similarDiscussions) {
        items.add('similarDiscussions', this.sources[0].view(this.similarSearches.getValue()));
      }
    }
  });

  override(DiscussionComposer.prototype, "oncreate", function (original, vnode) {
    let sources = this.sources;
    if (!sources?.length) return;

    const container = vnode?.dom?.getElementsByClassName('item-discussionTitle')[0];
    if (!container) return;

    const input = container.getElementsByTagName('INPUT')[0];
    if (!input) return;

    input.addEventListener('input', (e) => {
      if (!this.similarSearches) return;
      this.similarSearches.setValue(e.target?.value);

      const query = this?.title()?.toLowerCase();

      if (!query) return;

      let search = this;
      let state = search.similarSearches;

      if (search.searchTimeout) clearTimeout(search.searchTimeout);
      
      search.searchTimeout = window.setTimeout(() => {
        if (state.isCached(query)) return;

        if (query.length >= 3) {
          search.sources?.map((source) => {
            if (!source.search) return;

            //search.loadingSources++;

            source.search(query).then(() => {
              //search.loadingSources = Math.max(0, search.loadingSources - 1);
              m.redraw();
            });
          });
        }

        state.cache(query);
        //m.redraw();
      }, 350);
    });
  });

  override(DiscussionComposer.prototype, "onremove", function (original) {
    let search = this;
    if (search.searchTimeout) clearTimeout(search.searchTimeout);
  });
});
